'use client'
import { ComponentType, FC, PropsWithChildren } from 'react'
import { AppLayout } from '@/root/modules/tuuleliinid'
import { Prices } from '@/root/modules/tuuleliinid/SelectTicketPage/components/Prices'
import BookingCartProvider from '@/root/shared-providers/BookingCart'
import { SWRConfig } from 'swr'
import { swrConfig } from '@/root/utils/swr/booking-process-config'
import { CountryItem, Locale, Reservation, SailPackage } from '@/root/shared-types'
import type { SailRefParam } from '@/root/shared-types/selectTicketPage/selectTicket'
import { BookingContainer } from '@/root/components/tuuleliinid'

type Props = {
  countries: CountryItem[]
  locale: Locale
  routeBaseInfo: SailPackage
  sailParams: SailRefParam[]
  reservation?: Reservation
  token?: string
  /** The page frame. The TL header and footer by default; the trial theme passes its unbranded one. */
  Layout?: ComponentType<PropsWithChildren>
}

export const SelectTicketPage: FC<Props> = ({
  countries,
  sailParams,
  routeBaseInfo,
  reservation,
  Layout = AppLayout,
}) => {
  return (
    <Layout>
      <BookingContainer>
        <BookingCartProvider>
          <SWRConfig value={swrConfig}>
            <Prices
              sailParams={sailParams}
              routeBaseInfo={routeBaseInfo}
              countries={countries}
              reservation={reservation}
            />
          </SWRConfig>
        </BookingCartProvider>
      </BookingContainer>
    </Layout>
  )
}
